import gql from 'graphql-tag';

export default gql`
  fragment prefectureFragment on Prefecture {
    id
    identifier
    name
  }
`;
